export default __webpack_public_path__ + "static/media/asia_text.4e17531d.png";